import React from 'react'
import PropTypes from 'prop-types'
import { browserHistory, Router } from 'react-router'
import { Provider } from 'react-redux'
import axios from 'axios'

import { SERVER_URL } from '../config'
import { initAxios } from '../store/auth'
import { initAxios as initContractAxios } from '../store/authContract'
import { logPageView } from '../utils/googleAnalytics'
import {
  messages,
  language,
  IntlProvider,
} from '../utils/i18n'

import 'font-awesome/scss/font-awesome.scss'
axios.defaults.baseURL = SERVER_URL

export default class App extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    routes: PropTypes.object.isRequired,
    locale: PropTypes.string,
  };

  static defaultProps = {
    locale: language
  };

  constructor (props) {
    super(props)
    initAxios(props.store)
    initContractAxios(props.store)
  }

  shouldComponentUpdate () {
    return false
  }

  render () {
    const {
      store,
      locale,
      routes,
    } = this.props
    return (
      <Provider store={store}>
        <IntlProvider key={locale} locale={locale} messages={messages}>
          <Router
            history={browserHistory}
            children={routes}
            onUpdate={logPageView}
          />
        </IntlProvider>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js